var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "estate-share-container", attrs: { id: "estate-share" } },
    [
      _c(
        "modal",
        {
          ref: "calculate-mortgage",
          attrs: {
            name: "share-with-friend",
            "extra-class": "share-with-friend-modal full-screen-modal"
          }
        },
        [
          _c(
            "template",
            { slot: "body" },
            [
              _c("share-with-friend", {
                attrs: { "estate-id": _vm.estate.id, type: _vm.estate.ad_type }
              })
            ],
            1
          )
        ],
        2
      ),
      _vm._v(" "),
      _c("img", {
        attrs: {
          src: "/img/icons/share.svg",
          alt: _vm.lang.share,
          width: "24",
          height: "24"
        },
        on: { click: _vm.toggleMenu }
      }),
      _vm._v(" "),
      _vm.show
        ? _c("div", { staticClass: "estate-share-menu" }, [
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://api.whatsapp.com/send?text=" +
                    _vm.title +
                    " - " +
                    _vm.location,
                  target: "_blank"
                },
                on: { click: _vm.track }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "share-whatsapp",
                    src: "/img/icons/share-whatsapp.svg"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { href: "fb-messenger://share/?link=" + _vm.location },
                on: { click: _vm.messengerShare }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "share-messenger",
                    src: "/img/icons/share-messenger.svg"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { href: _vm.facebookShareLink },
                on: { click: _vm.facebookShare }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "share-facebook",
                    src: "/img/icons/share-facebook.svg"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: { href: _vm.twitterShareLink },
                on: { click: _vm.twitterShare }
              },
              [
                _c("img", {
                  attrs: {
                    alt: "share-twitter",
                    src: "/img/icons/share-twitter.svg"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                ref: "cp_container",
                staticClass: "copy",
                on: { click: _vm.copy }
              },
              [
                _c("img", {
                  attrs: { alt: "copy", src: "/img/icons/copy.svg" }
                })
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }